/* eslint-disable camelcase */
import React from 'react';

import { useStateCode } from '~state/getStateField';
import ContentDiv from '../common/ContentDiv';
import useRegisterRedirect from './useRegisterRedirect';

function IneligibleCitizenship() {
  const stateCode = useStateCode();

  useRegisterRedirect('ineligible-citizenship');
  if (!stateCode) {
    return null;
  }

  return (
    <ContentDiv>
      <h1>Sorry, you must be a US citizen to register</h1>
      <p>Only US citizens may register to vote.</p>
    </ContentDiv>
  );
}

export default IneligibleCitizenship;
